// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file error/error_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file error/error_model.proto.
 */
export const file_error_error_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChdlcnJvci9lcnJvcl9tb2RlbC5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiGAoWUmVzb3VyY2VFeGhhdXN0ZWRFcnJvciIUChJVbmltcGxlbWVudGVkRXJyb3IiIAoNSW50ZXJuYWxFcnJvchIPCgdtZXNzYWdlGAEgASgJIhIKEFVuYXZhaWxhYmxlRXJyb3JCHgoaY29tLmdlbS5iZmYuY2FsbHMuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * HTTP Mapping: 429 Too many requests
 *
 * @generated from message com.gem.bff.contract.ResourceExhaustedError
 */
export type ResourceExhaustedError = Message<'com.gem.bff.contract.ResourceExhaustedError'> & {};

/**
 * Describes the message com.gem.bff.contract.ResourceExhaustedError.
 * Use `create(ResourceExhaustedErrorSchema)` to create a new message.
 */
export const ResourceExhaustedErrorSchema: GenMessage<ResourceExhaustedError> =
  /*@__PURE__*/
  messageDesc(file_error_error_model, 0);

/**
 * HTTP Mapping: 501 Not Implemented
 *
 * @generated from message com.gem.bff.contract.UnimplementedError
 */
export type UnimplementedError = Message<'com.gem.bff.contract.UnimplementedError'> & {};

/**
 * Describes the message com.gem.bff.contract.UnimplementedError.
 * Use `create(UnimplementedErrorSchema)` to create a new message.
 */
export const UnimplementedErrorSchema: GenMessage<UnimplementedError> =
  /*@__PURE__*/
  messageDesc(file_error_error_model, 1);

/**
 * HTTP Mapping: 500 Bad Request
 *
 * @generated from message com.gem.bff.contract.InternalError
 */
export type InternalError = Message<'com.gem.bff.contract.InternalError'> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message com.gem.bff.contract.InternalError.
 * Use `create(InternalErrorSchema)` to create a new message.
 */
export const InternalErrorSchema: GenMessage<InternalError> =
  /*@__PURE__*/
  messageDesc(file_error_error_model, 2);

/**
 * HTTP Mapping: 503 Service Unavailable
 * client can retry just the failing call
 *
 * @generated from message com.gem.bff.contract.UnavailableError
 */
export type UnavailableError = Message<'com.gem.bff.contract.UnavailableError'> & {};

/**
 * Describes the message com.gem.bff.contract.UnavailableError.
 * Use `create(UnavailableErrorSchema)` to create a new message.
 */
export const UnavailableErrorSchema: GenMessage<UnavailableError> =
  /*@__PURE__*/
  messageDesc(file_error_error_model, 3);
